import { PrimitiveType, useIntl } from "react-intl";

import { getServicedeskMailto } from "../utils/get-servicedesk-mailto";

type MessageDescriptor = {
  id: string;
  defaultMessage: string;
  values?: Record<string, PrimitiveType>;
};

export function useServicedeskMailto(subject: MessageDescriptor, body: MessageDescriptor): string {
  const intl = useIntl();

  const emailSubject = intl.formatMessage(
    { id: subject.id, defaultMessage: subject.defaultMessage },
    subject.values
  );
  const emailBody = intl.formatMessage(
    { id: body.id, defaultMessage: body.defaultMessage },
    body.values
  );

  return getServicedeskMailto(emailSubject, emailBody);
}
